import { render } from "./Incident.vue?vue&type=template&id=457b0f10"
import script from "./Incident.vue?vue&type=script&lang=js"
export * from "./Incident.vue?vue&type=script&lang=js"

import "./Incident.vue?vue&type=style&index=0&id=457b0f10&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__